import { Outlet } from "react-router-dom";
import { DiningWaveProvider } from "@/context/DiningWaveContext";
import WaveSelector from "@/pages/dining/_WaveSelector";
import { UtensilsCrossed } from "lucide-react";

export default function DiningWrapper() {
  return (
    <DiningWaveProvider>
      <div className="flex items-center justify-between gap-3 flex-wrap mb-5 pb-4 border-b border-border" data-testid="dining-topbar">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <UtensilsCrossed className="h-4 w-4" />
          <span className="font-medium text-foreground">Dining</span>
          <span className="hidden sm:inline">· Facturación de catering por restaurantes</span>
        </div>
        <WaveSelector />
      </div>
      <Outlet />
    </DiningWaveProvider>
  );
}
